import React from 'react';

export default () => <div className="logo">
  <a href="/">
    <span className="logo-pb">pb</span>
    <span className="logo-rally">rally</span>
  </a>
</div>